
































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
@Component
export default class storeinfomanagecreateoredit extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop() id: number;
    @Prop({ type: Number, default: undefined }) merchantId: number;
    model: proxy.AdvanceMoneyAdjustOrderDto = new proxy.AdvanceMoneyAdjustOrderDto();
    fxArr = [];
    randomid = Math.random();
    get areaProx() {
        return new proxy.AreaServiceProxy();
    }
    save() {
        if (this.randomid == 0) {
      this.$Notice.error({ title: "单据已创建,请不要重复创建" });
      return;
    }
    this.randomid = 0;
        new proxy.AdvanceMoneyAdjustOrderServiceProxy().createOrUpdate(this.model).then(() => {
            (this.$refs.roleForm as any).resetFields();
            this.$Notice.success({ title: "保存成功" });
            this.$emit("save-success");
            this.$emit("input", false);
        });
    }
    cancel() {
        (this.$refs.roleForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.randomid = Math.random();
            new proxy.AdvanceMoneyAdjustOrderServiceProxy().queryModel(this.id).then((x) => {
                this.model = x;
                this.model.merchantId = this.merchantId;
            });

            let req = new proxy.MerchantSimpleInputDto();
 
            new proxy.MerchantServiceProxy().queryAllList(req).then((x) => {
                this.fxArr = x;
            });
        }
    }
    roleRule = {};
}
